var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { E_QPC_VERIFICATION_TYPE, } from 'src/services/cases/types';
import { assertChallengeIsFinished, castChallengeStatus, extractDataFromElement, filterControlsByScoreType, getKYCDescriptionForControl, getScoreMachine, isChallengeType, parseExtractedData, sortControlsListByStatus, } from 'src/redux/cases/helpers/qpcConverter';
import { flatArrays, getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { E_STATUS } from 'src/shared/types';
export var removeDeletedData = function (element) {
    var sides = element.sides, documents = element.documents;
    return __assign(__assign({}, element), { documents: documents.filter(function (doc) { return !(doc.deleted || doc.deleted === true); }), sides: sides
            .map(function (side) { return (__assign(__assign({}, side), { uploads: side.uploads.filter(function (upload) { return !(upload.deleted || upload.deleted === true); }) })); })
            .filter(function (side) { return side.uploads.length > 0; }) });
};
// To be done after removeDeletedData processing
export var removeInvalidElement = function (element) {
    var sides = element.sides, challenges = element.challenges;
    var isValidSides = sides.filter(function (side) { return side.uploads.length > 0; }).length > 0 || challenges.length > 0;
    if (isValidSides) {
        return element;
    }
    return null;
};
export var getAssetsFromElement = function (requiredElement) {
    var type = requiredElement.type, challenges = requiredElement.challenges, documents = requiredElement.documents;
    var isChallenge = isChallengeType(type);
    var allAssetsFromDocument = flatArrays(documents.map(function (doc) { return doc.faces.map(function (face) { return ({ id: face.id, assets: face.assets }); }); }));
    // if challenge we merge challenge and documents assets
    if (isChallenge) {
        var mostRecentChallenge = challenges.length
            ? challenges.reduce(function (prev, current) { return (prev.studyNumber > current.studyNumber ? prev : current); })
            : null;
        return __spreadArray([{ id: mostRecentChallenge.id, assets: mostRecentChallenge.result.assets }], allAssetsFromDocument, true);
    }
    return allAssetsFromDocument || [];
};
export var formatElement = function (i18n, studyElement, requiredElement) {
    var _a, _b, _c, _d, _e;
    var applicantId = requiredElement.applicantId, id = requiredElement.id, challenges = requiredElement.challenges, documents = requiredElement.documents, label = requiredElement.label, sides = requiredElement.sides, type = requiredElement.type;
    var documentsNotDeleted = documents.filter(function (doc) { return doc.deleted !== true; });
    // As old parser we take last document (visibly is functional choice)
    var documentDisplayed = documentsNotDeleted.filter(function (doc) { return doc.faces.filter(function (face) { return face.display && face.deleted !== true; }).length > 0; });
    var lastDocument = documentDisplayed.length ? documentDisplayed[documentDisplayed.length - 1] : null;
    var allDocumentsControlsMerged = flatArrays(documentsNotDeleted.map(function (document) { return document.controls; }));
    // Due to structure difference between challenge and sides we need a dedicated processing
    // Define study number by challenge for liveness and scanId or by sides if other
    var docControls = [];
    var uploadsWithSide = sides.flatMap(function (side) {
        var _a = side.uploads, uploads = _a === void 0 ? [] : _a;
        var mostRecentStudyNumber = uploads.reduce(function (max, current) { return (current.studyNumber > max ? current.studyNumber : max); }, 0);
        return uploads
            .filter(function (upload) { return upload.studyNumber === mostRecentStudyNumber && upload.deleted !== true && Boolean(upload.downloadUrl); })
            .map(function (upload) { return [upload, side]; });
    });
    var deduplicatedUploads = uploadsWithSide.reduce(function (acc, _a) {
        var upload = _a[0], side = _a[1];
        var isDuplicate = acc.some(function (_a) {
            var item = _a[0];
            return (upload.id && item.id === upload.id) || (upload.downloadUrl && item.downloadUrl === upload.downloadUrl);
        });
        return isDuplicate ? acc : __spreadArray(__spreadArray([], acc, true), [[upload, side]], false);
    }, []);
    var sidesFiles = deduplicatedUploads.map(function (_a) {
        var upload = _a[0], side = _a[1];
        return ({
            url: upload.downloadUrl,
            name: side.label,
            id: upload.id,
        });
    });
    var mostRecentChallenge = challenges.length
        ? challenges.reduce(function (prev, current) { return (prev.studyNumber > current.studyNumber ? prev : current); })
        : null;
    var lastDocumentAssets = flatArrays(lastDocument === null || lastDocument === void 0 ? void 0 : lastDocument.faces.map(function (item) {
        return item.assets.map(function (rslt) { return ({
            url: rslt.downloadUrl,
            name: rslt.assetType,
        }); });
    }));
    var challengesFiles = ((_b = (_a = mostRecentChallenge === null || mostRecentChallenge === void 0 ? void 0 : mostRecentChallenge.result) === null || _a === void 0 ? void 0 : _a.assets) === null || _b === void 0 ? void 0 : _b.map(function (assetItem) { return ({
        url: assetItem.downloadUrl,
        name: assetItem.assetType,
    }); })) || [];
    var docFiles = __spreadArray(__spreadArray(__spreadArray([], sidesFiles, true), lastDocumentAssets, true), challengesFiles, true).filter(function (file, index, self) {
        return index === self.findIndex(function (f) { return (file.id && f.id === file.id) || (file.url && f.url === file.url); });
    });
    var extractedData = extractDataFromElement(lastDocument);
    var isChallenge = isChallengeType(type);
    if (isChallenge && assertChallengeIsFinished(mostRecentChallenge)) {
        var challengeStatus = castChallengeStatus((_c = mostRecentChallenge === null || mostRecentChallenge === void 0 ? void 0 : mostRecentChallenge.result) === null || _c === void 0 ? void 0 : _c.status);
        var controlDescription = getPropsByKeyPath(i18n, "modules.globalView.kyc.".concat(type, ".").concat(challengeStatus))
            .replace('$reason', (_d = mostRecentChallenge === null || mostRecentChallenge === void 0 ? void 0 : mostRecentChallenge.result) === null || _d === void 0 ? void 0 : _d.reason)
            .replace('$provider', (_e = mostRecentChallenge === null || mostRecentChallenge === void 0 ? void 0 : mostRecentChallenge.result) === null || _e === void 0 ? void 0 : _e.configurationName);
        docControls = [
            {
                code: 'challenge',
                description: controlDescription,
                isMRZ: false,
                status: challengeStatus,
                values: [],
                scoreTags: [],
            },
        ];
    }
    if (allDocumentsControlsMerged.length > 0) {
        var controlsMergedParsed = allDocumentsControlsMerged
            .map(function (control) {
            var isMRZ = ['document.mrzCheckDigits', 'document.mrzSyntax'].indexOf(control.code) !== -1;
            var scoreTagsParsed = control.scoreTypes
                ? Array.isArray(control.scoreTypes)
                    ? control.scoreTypes
                    : [control.scoreTypes]
                : [];
            return {
                code: control.code,
                description: getKYCDescriptionForControl(i18n, control),
                isMRZ: isMRZ,
                status: E_STATUS[control.status] || E_STATUS.UNKNOWN,
                values: [],
                scoreTags: scoreTagsParsed,
            };
        })
            .sort(sortControlsListByStatus);
        docControls = __spreadArray(__spreadArray([], docControls, true), controlsMergedParsed, true);
    }
    var docControlsFiltered = lastDocument ? filterControlsByScoreType(lastDocument) : isChallenge ? docControls : [];
    var isNoControl = docControls.length === 0;
    var scoreMachine = getScoreMachine(docControlsFiltered);
    var documentStatus = E_STATUS[studyElement.status.toUpperCase()] || E_STATUS.UNKNOWN;
    return {
        applicantId: applicantId,
        type: type,
        controls: {
            collection: docControls,
            targetScore: (lastDocument === null || lastDocument === void 0 ? void 0 : lastDocument.targetScoreType) || null,
        },
        files: docFiles,
        id: id,
        isHistory: false,
        label: label,
        preview: '',
        machineKYC: isNoControl ? null : scoreMachine,
        nbOfFiles: docFiles.length,
        status: { value: documentStatus, isLoading: false },
        studyNumber: studyElement.studyNumber,
        isFilesToMerge: false,
        extractedData: parseExtractedData(extractedData),
        decisionDisabled: !studyElement.statusUpdateAllowed,
    };
};
export var processSession = function (requiredElement) {
    if (!requiredElement) {
        return null;
    }
    var removedDeletedData = removeDeletedData(requiredElement);
    var removedInvalidElement = removeInvalidElement(removedDeletedData);
    return removedInvalidElement;
};
/* Final verifications are represented by the verificationItems, we need to search through all the sessions the one which matches with these final verifications */
export var getAllLatestElements = function (sessionsItems, verificationsItems) {
    var elements = {
        proofRequirements: {},
        verifications: {},
    };
    sessionsItems.forEach(function (sessionItem) {
        sessionItem.proofRequirements.forEach(function (proofRequirement) {
            proofRequirement.acceptedProofs.forEach(function (acceptedProof) {
                acceptedProof.requiredElements.forEach(function (requiredElement) {
                    var id = requiredElement.id;
                    var elementProcessed = processSession(requiredElement);
                    var isElementValid = !!elementProcessed;
                    if (isElementValid) {
                        elements.proofRequirements[id] = __assign(__assign({}, requiredElement), { applicantId: sessionItem.applicantIds[0] });
                    }
                });
            });
        });
        sessionItem.verifications.forEach(function (verification) {
            var _a;
            var id = verification.id;
            var verificationItem = verificationsItems.find(function (verif) { return verif.id === id; });
            // We ensure that the verificationItem is correctly linked to the current sessionItem
            if ((_a = verificationItem === null || verificationItem === void 0 ? void 0 : verificationItem.sessionIds) === null || _a === void 0 ? void 0 : _a.includes(sessionItem.id)) {
                elements.verifications[id] = __assign(__assign({}, verificationItem), { applicantId: sessionItem.applicantIds[0] });
            }
        });
    });
    return elements;
};
export var formatStatus = function (status) {
    if (status === 'ERROR') {
        return E_STATUS.KO;
    }
    return E_STATUS[status.toUpperCase()] || E_STATUS.UNKNOWN;
};
export var parseControlForVerification = function (i18n, verificationResult, verificationType, verificationReason, verificationReportCodes) {
    var isSepamail = verificationType === E_QPC_VERIFICATION_TYPE.SEPA_MAIL;
    var verificationStatus = formatStatus(verificationResult.status);
    // Don't use formatStatus here cause we doing specific i18n mapping for each status
    var i18nKey = "globalView.documentList.verification.".concat(verificationType.toLowerCase(), ".").concat(verificationResult.status.toLowerCase());
    var controlDescription = getPropsByKeyPath(i18n.modules, i18nKey);
    if (!controlDescription) {
        console.error("[Verification] Missing translation for key: \"".concat(i18nKey, "\" (verificationType: \"").concat(verificationType, "\", status: \"").concat(verificationResult.status, "\")"));
    }
    if (isSepamail) {
        var controlForStatus = {
            code: 'verification',
            status: formatStatus(verificationResult.status),
            description: "".concat(controlDescription, " ").concat(verificationReason || '').trim(),
            values: [],
            isMRZ: false,
        };
        var controlsReasons = verificationReportCodes.map(function (reportCode) { return ({
            code: reportCode.code,
            status: formatStatus(reportCode.status),
            description: reportCode.fullMessage,
            values: [],
            isMRZ: false,
        }); });
        return __spreadArray([controlForStatus], controlsReasons, true);
    }
    return [
        {
            code: 'verification',
            status: verificationStatus,
            description: controlDescription,
            values: [],
            isMRZ: false,
        },
    ];
};
export var formatVerificationElement = function (i18n, studyElement, assets, verification, requiredItemsVerification) {
    var studyElementId = studyElement.elementId.id;
    var requiredVerification = requiredItemsVerification[studyElementId];
    if (!requiredVerification) {
        return null;
    }
    var id = verification.id, label = verification.label, results = verification.results, assetSources = verification.assetSources, reason = verification.reason, reportCodes = verification.reportCodes;
    var result = results === null || results === void 0 ? void 0 : results.reduce(function (acc, curr) { return (acc.studyNumber > curr.studyNumber ? acc : curr); });
    var docFiles = [];
    var isFacematch = verification.type === E_QPC_VERIFICATION_TYPE.FACEMATCH;
    if (isFacematch) {
        assetSources === null || assetSources === void 0 ? void 0 : assetSources.forEach(function (assetSource) {
            var docId = assetSource.id.id;
            var assetType = assetSource.assetType;
            var asset = assets.find(function (asset) { return asset.id === docId; });
            if (asset) {
                var assetItem = asset.assets.find(function (assetItem) { return assetItem.assetType === assetType; });
                if (assetItem) {
                    docFiles.push({ url: assetItem.downloadUrl, name: assetItem.assetType });
                }
            }
        });
    }
    var controls = parseControlForVerification(i18n, result, verification.type, reason, reportCodes);
    var isNoControl = controls.length === 0;
    var scoreMachine = getScoreMachine(controls);
    return {
        // @ts-ignore
        applicantId: requiredVerification.applicantId,
        controls: {
            collection: controls,
            targetScore: null,
        },
        id: id,
        isHistory: false,
        files: docFiles,
        type: verification.type,
        label: label,
        preview: '',
        nbOfFiles: isFacematch ? 1 : docFiles.length,
        status: { value: formatStatus(studyElement.status), isLoading: false },
        studyNumber: studyElement.studyNumber,
        isFilesToMerge: isFacematch,
        machineKYC: isNoControl ? null : scoreMachine,
        extractedData: { all: [], mrz: null },
        decisionDisabled: !studyElement.statusUpdateAllowed,
    };
};
// Keep first id for one verification (using reduce to perform filter, parsing on the same loop and format to obj[id])
export var parseVerificationItem = function (verifications) {
    return verifications.reduce(function (acc, verification) {
        var _a;
        var isNoResults = verification.results.length < 1;
        var isVerificationExist = !!acc[verification.id];
        if (isNoResults || isVerificationExist) {
            return acc;
        }
        return __assign(__assign({}, acc), (_a = {}, _a[verification.id] = verification, _a));
    }, {});
};
export var handleIndependentVerifications = function (verificationsItems) {
    return verificationsItems
        .filter(function (verification) { return !verification.sessionIds; })
        .reduce(function (acc, curr) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[curr.id] = curr, _a)));
    }, {});
};
export var parseQPCDocumentsElements = function (i18n, studyElement, sessionItems, verificationsItems) {
    // Retrieve main information, do all filter and parsing we want before merging with studyElement to improve algo complexity
    var retrievedElements = getAllLatestElements(sessionItems, verificationsItems);
    var independentVerifications = handleIndependentVerifications(verificationsItems);
    var assetsFromElements = flatArrays(Object.values(retrievedElements.proofRequirements).map(function (item) { return getAssetsFromElement(item); }));
    var parsedVerifications = parseVerificationItem(verificationsItems);
    var allVerificationsElement = __assign(__assign({}, retrievedElements.verifications), independentVerifications);
    var studyElementParsed = studyElement.reduce(function (acc, studyElementItem) {
        var elementId = studyElementItem.elementId;
        var isVerification = elementId.type !== 'required-element';
        var associatedElement = isVerification
            ? parsedVerifications[elementId.id]
            : retrievedElements.proofRequirements[elementId.id];
        var element = associatedElement
            ? isVerification
                ? formatVerificationElement(i18n, studyElementItem, assetsFromElements, associatedElement, allVerificationsElement)
                : formatElement(i18n, studyElementItem, associatedElement)
            : null;
        return element ? __spreadArray(__spreadArray([], acc, true), [element], false) : acc;
    }, []);
    return studyElementParsed;
};
